import React from 'react'
import { GrStatusGoodSmall } from 'react-icons/gr';
import { GrStatusGood } from 'react-icons/gr';
import useIsInViewport from 'use-is-in-viewport'

import Container from '../../../utils/Container'
import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Button from '../../../elements/buttons/Button'
import bgTraductionTypes from '../../../../medias/images/bg-traductionTypes.svg'

const TraductionTypes = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} bg-cover bg-right mt-28 lg:mt-32 pt-36 md:pt-60 lg:pt-68 pb-14 w-full`} 
			style={{backgroundImage: `url(${bgTraductionTypes})`}}
		>

			<Container classe="pt-32 md:pt-5 pb-10">
				<div className="text-center">
					<Heading2 >Types de traduction</Heading2>
					{/*<Heading3>Une méthodologie propre</Heading3>*/}
				</div>

				<div className="flex flex-col md:flex-row md:justify-between space-y-10 md:space-y-0 md:space-x-4 mt-8 md:mt-10">
					<article>
						<h4 className="flex items-center text-secondary font-secondary font-semibold">
							<GrStatusGoodSmall className="mr-2 md:mr-3 inline-block w-5 text-primary " />
							<strong className="opacity-90">Traduction générale</strong>
						</h4>
						<Paragraph>
							Nous entendons par traduction générale une traduction qui ne nécessite pas de domaine de spécialisation.
						</Paragraph>
					</article>

					<article>
						<h4 className="flex items-center text-secondary font-secondary font-semibold">
							<GrStatusGoodSmall className="mr-2 md:mr-3 inline-block w-5 text-primary " />
							<strong className="opacity-90">Traduction technique</strong>
						</h4>
						<Paragraph>
							Faites traduire vos contenus portant sur des sujets <b>médicaux</b>, <b>financiers</b>, <b>informatiques</b>, de la <b>modes</b> et plus encore.
						</Paragraph>
					</article>

					<article>
						<h4 className="flex items-center text-secondary font-secondary font-semibold">
							<GrStatusGoodSmall className="mr-2 md:mr-3 inline-block w-5 text-primary " />
							<strong className="opacity-90">Traduction urgente</strong>
						</h4>
						<Paragraph>
							Vous avez une traduction à effectuer dans un <b>délai très court </b>, rassurez-vous, vous serez satisfait en temps et en heure.
						</Paragraph>
					</article>
				</div>

				<div className="w-full flex justify-center">
					<Button
						link="/contact"
						classe="mt-10 mx-auto"
					>
						Traduire un projet
					</Button>
				</div>
			</Container>
		</section>
	)
}

export default TraductionTypes